import { useState } from "react";
import api, { formatErr } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function Settings() {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const change = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/admin/change-password", {
        current_password: cur,
        new_password: next,
      });
      toast.success("Password updated");
      setCur("");
      setNext("");
      setConfirm("");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="settings-page">
      <h2 className="font-serif font-bold text-2xl text-[#1A3A5C]">Settings</h2>

      <Card className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <Lock className="w-5 h-5 text-[#1A3A5C]" />
          <h3 className="font-serif font-bold text-lg text-[#1A3A5C]">
            Change Password
          </h3>
        </div>
        <form onSubmit={change} className="space-y-3">
          <div>
            <Label>Current Password</Label>
            <Input
              type="password"
              required
              value={cur}
              data-testid="current-password"
              onChange={(e) => setCur(e.target.value)}
            />
          </div>
          <div>
            <Label>New Password</Label>
            <Input
              type="password"
              required
              value={next}
              data-testid="new-password"
              onChange={(e) => setNext(e.target.value)}
            />
          </div>
          <div>
            <Label>Confirm New Password</Label>
            <Input
              type="password"
              required
              value={confirm}
              data-testid="confirm-password"
              onChange={(e) => setConfirm(e.target.value)}
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="change-password-submit"
            className="bg-[#1A3A5C] hover:bg-[#0F2236]"
          >
            {loading ? "Updating..." : "Update Password"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
